import { render, staticRenderFns } from "./HelpCatesAdd.vue?vue&type=template&id=4dcd173a&"
import script from "./HelpCatesAdd.vue?vue&type=script&lang=js&"
export * from "./HelpCatesAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports